import React from "react";

const PageBody = ({
  onSubmit,
  children,
  headerchildren,
  padding = "px-xl-5 px-lg-4 px-3 py-3",
  card = true,
  cardBodyClass = "card-body",
}) => {

  const Content = (
    <>
      {card ? (
        <div className="card">
          <div className={cardBodyClass}>
            <div className="row g-3">{children}</div>
          </div>
        </div>
      ) : (
        <div className="row g-3">{children}</div>
      )}
    </>
  );

  return (
    <div className={`${padding} page-body`}>
      <div className="row g-3">
        {headerchildren && (
          <div className="col-12 d-flex align-items-center justify-content-between flex-wrap">
            {headerchildren}
          </div>
        )}
        <div className="col-12">
          {onSubmit ? <form onSubmit={onSubmit}>{Content}</form> : Content}
        </div>
      </div>
    </div>
  );
};

export default PageBody;
